import { render } from "./cards_display.modules.vue?vue&type=template&id=9fb7e38e&ts=true"
import script from "./cards_display.modules.vue?vue&type=script&lang=ts"
export * from "./cards_display.modules.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__